import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

export const DrillDialog = ({ metric, onClose }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!metric) { setData(null); return; }
    api.get(`/admin/analytics/drill/${metric}`).then((r) => setData(r.data)).catch(() => setData({ title: "Fout", rows: [] }));
  }, [metric]);
  return (
    <Dialog open={!!metric} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg rounded-2xl" data-testid="drill-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">{data?.title || "Details"}</DialogTitle>
          <DialogDescription>Onderliggende gegevens achter dit cijfer.</DialogDescription>
        </DialogHeader>
        {!data ? (
          <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-muted-foreground" /></div>
        ) : data.rows.length === 0 ? (
          <p className="text-sm text-muted-foreground py-6 text-center">Nog geen gegevens.</p>
        ) : (
          <div className="max-h-[60vh] overflow-y-auto space-y-1.5 -mx-1 px-1" data-testid="drill-rows">
            {data.rows.map((r, i) => (
              <div key={i} className="bg-secondary/60 rounded-xl px-3.5 py-2.5 flex items-start justify-between gap-3" data-testid={`drill-row-${i}`}>
                <div className="min-w-0">
                  <p className="text-sm font-semibold truncate">{r.label}</p>
                  {r.sub && <p className="text-xs text-muted-foreground truncate">{r.sub}</p>}
                </div>
                <span className="text-xs font-mono text-muted-foreground shrink-0 text-right whitespace-nowrap">{r.value}</span>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
